var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled';
import { themeGet, space, display, border, borderRadius } from 'styled-system';
import { LocaleConsumer } from '../../providers/LocaleProvider';
import { themeWidth, themeHeight } from '../../theme/system-utilities';
import VisuallyHidden from '../VisuallyHidden';
var BottomCenterControlsGroup = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  list-style: none;\n  transform: translateY(100%) translateY(16px);\n"], ["\n  ", ";\n  ", ";\n  list-style: none;\n  transform: translateY(100%) translateY(16px);\n"])), display, space);
BottomCenterControlsGroup.defaultProps = {
    display: 'flex',
    m: 0,
    p: 0,
};
var ControlsItem = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), space);
ControlsItem.defaultProps = {
    mx: 1,
};
var ControlsItemButton = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: none;\n  background-color: ", ";\n\n  &[disabled] {\n    background-color: ", ";\n  }\n"], ["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: none;\n  background-color: ", ";\n\n  &[disabled] {\n    background-color: ", ";\n  }\n"])), display, space, border, borderRadius, themeWidth, themeHeight, themeGet('colors.gray.5'), themeGet('colors.gray.10'));
ControlsItemButton.defaultProps = {
    display: 'block',
    themeWidth: 2,
    themeHeight: 2,
    m: 0,
    p: 0,
    border: 'none',
    borderRadius: '100%',
};
var BottomControl = function (_a) {
    var goToSlide = _a.goToSlide, slideCount = _a.slideCount, currentSlide = _a.currentSlide, className = _a.className;
    return (React.createElement(BottomCenterControlsGroup, { className: className }, Array.from({ length: slideCount }, function (_, index) { return (React.createElement(ControlsItem, { key: index },
        React.createElement(LocaleConsumer, null, function (l10n) {
            var buttonLabel = l10n.replace.t('h24_go_to_item', {
                number: index + 1,
            });
            return (React.createElement(ControlsItemButton, { onClick: function () { return goToSlide(index); }, disabled: currentSlide === index, "data-testid": "carousel-control-goto-" + index, "aria-label": buttonLabel },
                React.createElement(VisuallyHidden, null, buttonLabel)));
        }))); })));
};
export default BottomControl;
var templateObject_1, templateObject_2, templateObject_3;
